{
    "name": "friskywebapp",
    "version": "2.6.0",
    "private": true,
    "scripts": {
        "postinstall": "nuxi prepare",
        "build": "nuxi generate",
        "serve": "nuxi dev",
        "serve:e2e": "nuxi dev --host 127.0.0.1 --port 5555",
        "preview": "nuxi preview",
        "test": "yarn unit && yarn e2e",
        "preview:e2e": "vite preview --outDir .output/public --host 127.0.0.1 --port 5555 --strictPort",
        "e2e": "yarn build --envName development && start-server-and-test \"yarn preview:e2e\" http://127.0.0.1:5555 \"cypress run --e2e\"",
        "e2e:open": "start-server-and-test \"yarn serve:e2e\" http://127.0.0.1:5555 \"cypress open --e2e\"",
        "lint": "eslint . && stylelint \"app/**/*.vue\" \"app/**/*.scss\"",
        "lint:fix": "eslint --fix . && stylelint --fix \"app/**/*.vue\" \"app/**/*.scss\"",
        "types": "nuxi typecheck",
        "dev": "nuxi dev --open --port 5555",
        "icons:build": "node scripts/build-icon-sprite.mjs",
        "new:component": "hygen component new",
        "dev:e2e": "yarn e2e:open",
        "unit": "TZ=America/New_York vitest run",
        "unit:related": "TZ=America/New_York vitest related --run",
        "ssr-probe": "vitest run --config vitest.ssr-probe.config.ts",
        "run-lighthouse": "start-server-and-test \"yarn preview --port 4173\" http://127.0.0.1:4173 \"lighthouse http://127.0.0.1:4173 --only-categories=performance --output html --output json --output-path lighthouse-report --chrome-flags=--headless\"",
        "test:ci": "yarn lint && yarn types && yarn unit --coverage && yarn ssr-probe && yarn e2e",
        "unit:watch": "TZ=America/New_York vitest"
    },
    "dependencies": {
        "@pinia/nuxt": "1.0.2",
        "@unhead/vue": "3.4.1",
        "ReconnectingWebSocket": "https://github.com/joewalnes/reconnecting-websocket",
        "component-emitter": "^1.3.0",
        "date-fns": "^2.16.1",
        "date-fns-tz": "^2.0.1",
        "lodash": "^4.17.20",
        "mixpanel-browser": "^2.73.0",
        "nprogress": "^0.2.0",
        "nuxt": "4.5.2",
        "pinia": "^4.0.3",
        "register-service-worker": "^1.7.2",
        "rrule": "^2.8.1",
        "soundmanager2": "^2.97.20170602",
        "susy": "^3.0.7",
        "swiper": "8.4.7",
        "vue": "^3.5.43",
        "vue-recaptcha": "2.0.3"
    },
    "devDependencies": {
        "@eslint/eslintrc": "^3",
        "@nuxt/eslint": "^1.17.0",
        "@nuxt/test-utils": "4.3.3",
        "@types/component-emitter": "^1",
        "@types/lodash": "^4",
        "@types/node": "^24",
        "@typescript-eslint/eslint-plugin": "^8",
        "@typescript-eslint/parser": "^8",
        "@vite-pwa/nuxt": "^1.1.1",
        "@vitejs/plugin-vue": "^6.0.8",
        "@vitest/coverage-v8": "^4.1.10",
        "@vue/compiler-sfc": "^3.5.43",
        "@vue/eslint-config-standard": "^8.0.1",
        "@vue/test-utils": "^2",
        "autoprefixer": "^10.5.4",
        "cypress": "^15.0.0",
        "devalue": "^5.9.4",
        "eslint": "^9",
        "eslint-config-prettier": "^10",
        "eslint-plugin-n": "^17",
        "eslint-plugin-vue": "^10",
        "globals": "^16",
        "hygen": "4.0.9",
        "jsdom": "^30.0.1",
        "lighthouse": "^13.4.1",
        "postcss-html": "^1.8.1",
        "postcss-scss": "^4.0.9",
        "prettier": "^2.8.8",
        "sass": "^1.102.0",
        "start-server-and-test": "^3.0.0",
        "stylelint": "^17.14.0",
        "stylelint-config-recess-order": "^7.7.0",
        "stylelint-config-recommended-scss": "^17.0.1",
        "stylelint-config-recommended-vue": "^1.6.1",
        "stylelint-order": "^8.1.1",
        "stylelint-scss": "^7.2.0",
        "typescript": "~5.9.3",
        "vite": "^8.2.0",
        "vitest": "^4.1.10",
        "vue-eslint-parser": "^10",
        "vue-tsc": "2.2.12"
    },
    "resolutions": {
        "postcss": "^8.5.28",
        "vite": "^8.2.0"
    },
    "browserslist": [
        "chrome >= 100",
        "edge >= 100",
        "firefox >= 100",
        "safari >= 15",
        "ios_saf >= 15"
    ],
    "engines": {
        "node": ">=24.0.0",
        "yarn": ">=1.0.0"
    }
}
